import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import queryString from 'query-string'
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import PaymentButton from '../../custom_components/Payment'
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Mic from "@material-ui/icons/Add";
import green from '@material-ui/core/colors/green';
// core components
import * as track from '../../data/track/track';
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";

import CardHeader from "src/components/Card/CardHeader.jsx";
import CardText from "src/components/Card/CardText.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";

import CardFooter from "src/components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import customSelectStyle from "src/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import ImageUpload from "src/components/CustomUpload/ImageUpload.jsx";
import * as model from '../../data/model';

import * as types from '../../types'
import { SSL_OP_NETSCAPE_CA_DN_BUG } from "constants";
import * as firebase from 'firebase/app';
import { createVerify } from "crypto";
import { string } from "prop-types";
const styles = {
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    ...customSelectStyle,
    select: {
        paddingTop: '10px'
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    registerButton: {
        float: "right"
    }
};
let categories = model.PodCastCatgory.getCategories();


interface CreateTrackProps {
    classes: any;
    connect: types.IState;
}
interface CreateTrackState {
    createTrackRequest: model.CreateTrackRequest;
    errors: Array<types.ValidationError>;
    fieldCheck: any;
}
let helper = new types.ValidationHelper();
helper.fields = [
    {
        field: 'title',
        rules: [new types.RequiredRule()]
    },
    {
        field: 'text',
        rules: [new types.RequiredRule()]
    }

];
class ValidateAndPurchase extends React.Component<CreateTrackProps, CreateTrackState> {
    constructor(props: CreateTrackProps) {
        super(props);
        let id = this.props['match'].params.request_id;
        let data = sessionStorage.getItem("requestId:" + id);
        let crt: model.CreateTrackRequest = undefined;

        if (data) {
            crt = JSON.parse(data) as model.CreateTrackRequest;
        }
        let tc = {...crt};
        tc['text']=crt.text;
        let errors = helper.validateForm(tc).errors;
        let fieldCheck = {};
        if(errors.length > 0)
        {
            fieldCheck['text'] = true;
            fieldCheck['title'] = true;
        }
        this.state = {
            createTrackRequest: crt,
            errors: errors,
            fieldCheck: fieldCheck

        };


    }



    async convertClick(e: any) {
        let s = { ...this.state };
        this.props.connect.lo_ctx.val().Track.processTrackRequest(s.createTrackRequest);
        track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.purchaseTrack);
        types.ViewState.navigate(types.ViewState.hashPodCastView(s.createTrackRequest.track.podcast_id))

    }
    wordCount(str: string) {
        return str.split(' ').length
    }

    change(field: string, value: any) {
        let s = { ...this.state };
        if (field == 'text') {
            s.createTrackRequest.text = value;
        }
        else {
            s.createTrackRequest.track[field] = value;
            s.fieldCheck[field] = true;
        }
        let errors: Array<types.ValidationError> = s.errors ? new Array<types.ValidationError>() : s.errors;
        errors = errors.filter(x => x.field != field);
        let vr = helper.validateField(s.createTrackRequest.track, field, value)
        if (vr) {
            errors = errors.concat(vr.errors)
        }
        s.errors = errors;
        this.setState(s);

    }
    render() {
        const { classes } = this.props;
        let me = this;

        let track = this.state.createTrackRequest.track;
        //this.props.match.params
        if (!this.state.createTrackRequest) {
            return (<div>This request has been expired.</div>)
        }
        let creditsNeeded = 0;
       // creditsNeeded = this.props.connect.lo_ctx.val().Transaction.getCreditsNeededForTrackRequest(this.state.createTrackRequest);
        let tc = {...this.state.createTrackRequest.track};
        tc['text']=this.state.createTrackRequest.text;
        let errors = helper.validateForm(tc).errors
        let hasErrors = errors.length > 0;
        if(hasErrors)
        {
           
        }
       // let formValid = this.state.createTrackRequest.text && this.state.createTrackRequest.track.title;

        return (

            <Card>
                <CardHeader color="rose" icon>
                    <CardIcon color="rose">
                        <Mic />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>Create Track</h4>
                </CardHeader>
                <CardBody>

                    <GridContainer>


                        <GridItem xs={12} sm={12} md={12}>
                            <div style={{
                                'display': 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <h2>
                                    {this.state.createTrackRequest.track.image_url &&
                                        <span style={{ padding: '10px' }}> <img src={this.state.createTrackRequest.track.image_url} width={60} height={60} />
                                        </span>
                                    }
                                    {track.title} </h2>
                            </div>
                            <div style={{
                                'display': 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <h3>

                                    {this.wordCount(this.state.createTrackRequest.text)} words.
                                 </h3>
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} >
                            <div style={{
                                'display': 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {creditsNeeded > this.props.connect.lo_CustomerBalance.val().credits &&
                                    <div style={{
                                        display: 'table',
                                        margin: '0 auto'
                                    }}>
                                        <h3>You need {creditsNeeded > this.props.connect.lo_CustomerBalance.val().credits} more credits.</h3>
                                        <PaymentButton />
                                    </div>
                                }
                                {creditsNeeded > 5 &&
                                    <div style={{
                                        display: 'table',
                                        margin: '0 auto'
                                    }}> Sorry this track is too long.  Try breaking it up into multiple tracks. </div>
                                }
                                {creditsNeeded <= this.props.connect.lo_CustomerBalance.val().credits && creditsNeeded <= 5 &&
                                    <div><div style={{
                                        display: 'table',
                                        margin: '0 auto'
                                    }}>
                                        <Button
                                            color="rose"
                                            onClick={this.convertClick.bind(this)}
                                            variant="contained"
                                            disabled={hasErrors}
                                            className={classes.registerButton}
                                        >
                                            <span>Create Track</span>

                                        </Button>
                                    </div>
                                        <div style={{
                                            display: 'table',
                                            margin: '0 auto'
                                        }}>
                                            <p className="firebaseui-tos firebaseui-tospp-full-message">By continuing, you are indicating that you accept our <br /> <a href="javascript:void(0)" className="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" className="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>.</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl
                                fullWidth
                            >
                                <CustomInput

                                    labelText="Title"
                                    fullWidth

                                    helpText={helper.getFirstError('title', this.state.errors)}
                                    success={this.state.fieldCheck['title'] && !helper.getFirstError('title', this.state.errors)}
                                    error={helper.getFirstError('title', this.state.errors)}
                                    inputProps={{
                                        value: track.title,
                                        onChange: (e) => {
                                            me.change('title', e.target.value)

                                        }
                                    }}


                                    margin="normal"
                                />
                            </FormControl>
                            <br></br>
                            <FormControl
                                fullWidth
                            >
                                <CustomInput
                                    id="filled-multiline-static"
                                    labelText="Full Text"
                                    helpText={helper.getFirstError('text', this.state.errors)}
                                    success={this.state.fieldCheck['text'] && !helper.getFirstError('text', this.state.errors)}
                                    error={helper.getFirstError('text', this.state.errors)}

                                    inputProps={{
                                        multiline: true,
                                        fullWidth: true,
                                        value: this.state.createTrackRequest.text,
                                        onChange: (e) => {
                                            me.change('text', e.target.value)
                                        }
                                    }}
                                    className={classes.textField}
                                    margin="normal"

                                />
                            </FormControl>
                            <br></br>
                            <FormControl
                                fullWidth
                            >
                                <CustomInput

                                    labelText="Soft Title"
                                    fullWidth
                                    className={classes.textField}
                                    value={track.soft_title}
                                    helpText={helper.getFirstError('soft_title', this.state.errors)}
                                    success={this.state.fieldCheck['soft_title'] && !helper.getFirstError('soft_title', this.state.errors)}
                                    error={helper.getFirstError('soft_title', this.state.errors)}
                                    inputProps={{

                                        onChange: (e) => {
                                            me.change('soft_title', e.target.value)

                                        }
                                    }}
                                    margin="normal"
                                />
                            </FormControl>
                            <br></br>
                            <FormControl
                                fullWidth
                            >
                                <CustomInput

                                    labelText="Author"
                                    fullWidth
                                    className={classes.textField}
                                    value={track.author}
                                    helpText={helper.getFirstError('author', this.state.errors)}
                                    success={this.state.fieldCheck['author'] && !helper.getFirstError('author', this.state.errors)}
                                    error={helper.getFirstError('author', this.state.errors)}
                                    inputProps={{

                                        onChange: (e) => {
                                            me.change('author', e.target.value)

                                        }
                                    }}
                                    margin="normal"
                                />
                            </FormControl>

                        </GridItem >


                        <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                                fullWidth>
                                <CustomInput

                                    labelText="Publisher"
                                    fullWidth
                                    className={classes.textField}
                                    value={track.publisher}
                                    helpText={helper.getFirstError('publisher', this.state.errors)}
                                    success={this.state.fieldCheck['publisher'] && !helper.getFirstError('publisher', this.state.errors)}
                                    error={helper.getFirstError('publisher', this.state.errors)}
                                    inputProps={{

                                        onChange: (e) => {
                                            me.change('publisher', e.target.value)

                                        }
                                    }}
                                    margin="normal"
                                />
                            </FormControl>
                            <br></br>
                            <FormControl
                                fullWidth
                            >
                                <CustomInput

                                    labelText="Copyright"
                                    fullWidth
                                    className={classes.textField}
                                    value={track.copyright}
                                    helpText={helper.getFirstError('copyright', this.state.errors)}
                                    success={this.state.fieldCheck['copyright'] && !helper.getFirstError('copyright', this.state.errors)}
                                    error={helper.getFirstError('copyright', this.state.errors)}
                                    inputProps={{

                                        onChange: (e) => {
                                            me.change('copyright', e.target.value)

                                        }
                                    }}
                                    margin="normal"
                                />
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth>
                                <CustomInput

                                    labelText="Description"
                                    fullWidth

                                    className={classes.textField}
                                    value={track.description}
                                    helpText={helper.getFirstError('description', this.state.errors)}
                                    success={this.state.fieldCheck['description'] && !helper.getFirstError('description', this.state.errors)}
                                    error={helper.getFirstError('description', this.state.errors)}
                                    inputProps={{

                                        onChange: (e) => {
                                            me.change('description', e.target.value)

                                        }
                                    }}
                                    margin="normal"
                                />
                            </FormControl>
                        </GridItem>

                    </GridContainer>



                </CardBody>

            </Card>

        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(ValidateAndPurchase));




// WEBPACK FOOTER //
// ./src/views/tracks/ValidateAndPurchase.tsx